// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAinqXwB0e3atiqnDsp_CUUAonzs0Gj8xQ",
  authDomain: "wedding-comment-d098b.firebaseapp.com",
  projectId: "wedding-comment-d098b",
  storageBucket: "wedding-comment-d098b.firebasestorage.app",
  messagingSenderId: "286403812416",
  appId: "1:286403812416:web:6ed746892806496a3fd3a5",
  measurementId: "G-JD2L796JQ8"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;